import { defineComponent as d, computed as l, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as n, createCommentVNode as f, normalizeStyle as h, createStaticVNode as v } from "vue";
const m = ["viewBox"], p = /* @__PURE__ */ t("mask", { id: "85c4bc9b-c5b3-4d06-928e-c49fb11f4aeb" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#85c4bc9b-c5b3-4d06-928e-c49fb11f4aeb)" }, k = { key: 0 }, u = /* @__PURE__ */ v('<path fill="#ff9811" d="M0 0h224l32 88-32 88-96 32L0 176Z"></path><path fill="#eee" d="m0 224 256-32 256 32v48l-32 24 32 24v48l-32 24 32 24v48l-256 32L0 464v-48l32-24-32-24v-48l32-24-32-24Z"></path><path fill="#496e2d" d="M224 0v176H0v48h512V0ZM0 272v48h512v-48zm0 96v48h512v-48zm0 96v48h512v-48z"></path><circle cx="355.6" cy="110.2" r="80.5" fill="#eee"></circle><circle cx="376.2" cy="91.9" r="73.8" fill="#496e2d"></circle><path fill="#eee" d="m370 76 47-20-27 44-4-50 34 38z"></path>', 6), g = { fill: "none" }, b = ["r"], z = /* @__PURE__ */ d({
  __name: "pk-jk",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, c = l(() => 512 + 2 * e.strokeWidth), o = l(() => -e.strokeWidth), a = l(() => 256 + e.strokeWidth / 2);
    return (x, y) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${c.value} ${c.value}`
    }, [
      p,
      t("g", _, [
        e.flagName ? (i(), r("title", k, n(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, m));
  }
});
export {
  z as default
};
//# sourceMappingURL=pk-jk-00aeac14.js.map
